// Twitter platform widgets.js — blockquote.twitter-tweet'i iframe-render eder.
// main.tsx app boot'ta script'i async preload eder; bu modül ise window.twttr
// hazır olana kadar bekler ve widgets.load çağırır.

declare global {
  interface Window {
    twttr?: {
      widgets: {
        load: (target?: Element | null) => void
      }
    }
  }
}

const SRC = 'https://platform.twitter.com/widgets.js'

let readyPromise: Promise<void> | null = null

function waitForTwttr(): Promise<void> {
  if (readyPromise) return readyPromise
  readyPromise = new Promise((resolve, reject) => {
    if (window.twttr?.widgets) {
      resolve()
      return
    }
    // Script'i ekle (henüz yoksa — main.tsx preload genelde halletti)
    if (!document.querySelector(`script[src="${SRC}"]`)) {
      const s = document.createElement('script')
      s.src = SRC
      s.async = true
      s.charset = 'utf-8'
      document.head.appendChild(s)
    }
    // window.twttr için polling — script load eventini kaçırmamak için defansif
    let tries = 0
    const interval = setInterval(() => {
      tries++
      if (window.twttr?.widgets) {
        clearInterval(interval)
        resolve()
      } else if (tries > 100) {
        clearInterval(interval)
        reject(new Error('twitter widgets.js timeout'))
      }
    }, 100)
  })
  return readyPromise
}

export async function loadTweet(rootEl: HTMLElement | null) {
  if (!rootEl) return
  try {
    await waitForTwttr()
    window.twttr?.widgets.load(rootEl)
  } catch (e) {
    console.warn('twitter widgets load failed', e)
  }
}
